import {Component, Injectable} from '@angular/core';
import {
    NgbDateStruct,
    NgbCalendar,
    NgbCalendarIslamicCivil,
    NgbCalendarIslamicUmalqura,
    NgbDatepickerI18n,
} from '@ng-bootstrap/ng-bootstrap';

const I18N_VALUES = {
    weekdays: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
    months: ['Q1', 'Q2', 'Q3', 'Q4', '', '', '', '', '', '', '', ''],
};

@Injectable()
export class QuarterPicker extends NgbDatepickerI18n {
    getWeekdayShortName(weekday: number) {
        return I18N_VALUES.weekdays[weekday - 1];
    }

    getMonthShortName(month: number) {
        return I18N_VALUES.months[month - 1];
    }

    getMonthFullName(month: number) {
        return this.getMonthShortName(month);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/ngbmomentpickers/quarter-picker/quarter-pricker.ts